export default __webpack_public_path__ + "static/media/deletar.8ad664f8.svg";